import { useDispatch } from 'react-redux';
import SignSVG from '../../assets/svgs/Sign up - Log in.svg';

import classes from './SiderElement.module.scss';
import { modalActions } from '../../store/modal-slice';

export default function SignupOrLogin({ text, language }) {
  const dispatch = useDispatch();
  const signHandler = () => {
    dispatch(modalActions.openLoginModal());
  };

  return (
    <div
      className={`${classes.link} ${classes[language]}`}
      onClick={signHandler}
    >
      <span>
        <img src={SignSVG} alt={text} className={classes.icon} />
      </span>
      <span className={classes['link-text']}>{text}</span>
    </div>
  );
}
